export default function normalizeDateRange(value: string): MomentRange | null {
    let res = null
    const dates: string[] = value.split('/')


    if (dates[0] && dates[1]) {
        const startMoment: Moment = momentDate(dates[0])
        const endMoment: Moment = momentDate(dates[0])

        // @ts-ignore
        res = startMoment.isValid() && endMoment.isValid() ? moment.range(startMoment,endMoment) : null
    }

    return res
}